"use client";

export default function CarouselArrow({
  direction = "right",
  onClick,
  disabled,
  ariaLabel,
  className = "",
}: {
  direction?: "left" | "right";
  onClick?: () => void;
  disabled?: boolean;
  ariaLabel: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`group/arrow flex size-12 cursor-pointer items-center justify-center rounded-xl border border-border bg-white text-accent shadow-[0_8px_24px_rgba(20,29,69,0.12)] transition-all duration-200 hover:border-transparent hover:bg-primary hover:text-white hover:shadow-[0_12px_28px_rgba(0,57,166,0.35)] disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-border disabled:hover:bg-white disabled:hover:text-accent disabled:hover:shadow-[0_8px_24px_rgba(20,29,69,0.12)] ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
        className={`size-5 transition-transform duration-200 ${
          direction === "left" ? "rotate-180" : ""
        }`}
      >
        <path
          d="M9 5.5L15.5 12L9 18.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
